import React, { useEffect, useState } from "react";
import {
  Container,
  Card,
  Title,
  Subtitle,
  Spinner,
  SuccessIcon,
  ErrorIcon,
} from "./styles/SetPersonalMobileStyles";
import { useSearchParams } from "react-router-dom";
import DasApi from "../../api/DasApi";

const COOKIE_NAME = "mobileId";
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

const setCookie = (name: string, value: string, maxAge: number): void => {
  const isLocalhost =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";
  const secureFlag = isLocalhost ? "" : "; secure";
  document.cookie = `${name}=${value}; max-age=${maxAge}; path=/${secureFlag}; SameSite=Lax`;
};

type Status = "idle" | "loading" | "success" | "error";

const SetPersonalMobile: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<Status>("idle");

  const serialNumber = searchParams.get("serialNumber") || "";

  useEffect(() => {
    async function register(): Promise<void> {
      setStatus("loading");

      try {
        const getMobileIdResponse = await DasApi.getMobileId(serialNumber);
        console.log(getMobileIdResponse);
        setCookie(COOKIE_NAME, getMobileIdResponse.mobileId, COOKIE_MAX_AGE);
        localStorage.setItem(serialNumber, getMobileIdResponse.mobileId)
        setStatus("success");
      } catch (e) {
        console.log(e);
        setStatus("error");
        return;
      }
    }

    register();
  }, [serialNumber]);

  return (
    <Container>
      <Card>
        {status === "loading" && (
          <>
            <Spinner />
            <Title>Registering device...</Title>
          </>
        )}

        {status === "success" && (
          <>
            <SuccessIcon>✓</SuccessIcon>
            <Title>Device Registered</Title>
            <Subtitle>Tap the tag again to continue.</Subtitle>
          </>
        )}

        {status === "error" && (
          <>
            <ErrorIcon>✕</ErrorIcon>
            <Title>Registration Failed</Title>
            <Subtitle>Please try tapping the tag again.</Subtitle>
          </>
        )}
      </Card>
    </Container>
  );
};
export default SetPersonalMobile;
